import 'stylesheets/product/powersuit';